import React from 'react';

export const Header = (props) => {
  return (
    <header id='header'>
      <div className='scroll-text'>
        <p>
          Water Purifier Repair &amp; Home Visit Charge - ₹199/- | Installation Charges - ₹499/- in Muzaffarpur. Call - +91-8271463038
        </p>
      </div>
    </header>
  )
}
